import { createSelector } from 'reselect';

import { getTradeInStore } from 'store/selectors';

export const getTradeInSettings = createSelector(getTradeInStore, (tradeIn) => tradeIn?.data);
